import { Text } from '@northladder/i18n';

import { translations } from '../../../translations';

interface IButtonBackProps {
  onClick: () => void;
}

/**
 * -----------------------------------------------------------------------------
 * Renders the back button that navigates the user back to the camera capture
 * from cropping or from preview mode to cropping.
 */
export function ButtonBack({ onClick }: IButtonBackProps) {
  return (
    <button
      className="
        form-btn-secondary bg-primary-600/60 w-auto border-2 border-gray-400
        text-gray-700
      "
      onClick={onClick}
      type="button"
    >
      <Text text={translations.cropping.back} />
    </button>
  );
}
